// Should only be used for testing purposes
export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
